import { AccountMemos } from "./AccountMemos";

export function AccountMemoDetail() {
    return (
        <section>
            <AccountMemos />
        </section>
    );
}